import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "NewsletterSignup",
    component: () => (__SERVER__ ? require("./newsletter-signup-view") : import("./newsletter-signup-view"))
});

export default definition;
